/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizersavefailed2Inputs */

const en_organizersavefailed2 = /** @type {(inputs: Organizersavefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That didn't work. Check the details and try again.`)
};

const de_organizersavefailed2 = /** @type {(inputs: Organizersavefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das hat nicht geklappt. Prüf die Angaben und versuch es noch einmal.`)
};

/**
* | output |
* | --- |
* | "That didn't work. Check the details and try again." |
*
* @param {Organizersavefailed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizersavefailed2 = /** @type {((inputs?: Organizersavefailed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizersavefailed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizersavefailed2(inputs)
	return de_organizersavefailed2(inputs)
});
export { organizersavefailed2 as "organizerSaveFailed" }